<script setup lang="ts">
const { locale } = useI18n()

const { data, error } = await usePage(
  `/api/gluon/fetchWhoWeArePage/${locale.value}/who_we_are.js`
)

if (error.value) {
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}
</script>

<template>
  <div>
    <SeoBase v-if="data?.seo" v-bind="data.seo" />
    <PagesWhoWeAre v-if="data" v-bind="data" />
  </div>
</template>
